export default {"src":"/_next/static/media/person_with_tie_24.38fa12d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};